<script>
  import { navigate } from 'svelte-routing';
  import { t } from '../i18nStore';

  let alertMessage = '';
  let showAlert = false;

  const tools = [
    {
      id: 'tax_rebate',
      titleKey: 'tools.tax_title',
      descKey: 'tools.tax_desc',
      path: '/tax-calculator',
      icon: 'receipt',
      color: '#1b5e20',
      bgColor: '#e8f5e9',
      badge: 'Tax Rebate',
      badgeColor: '#2e7d32',
      isAvailable: true
    },
    {
      id: 'open_account',
      titleKey: 'tools.open_account_title',
      descKey: 'tools.open_account_desc',
      path: '/open-account-calculator',
      icon: 'account_balance',
      color: '#b45309',
      bgColor: '#fef3c7',
      badge: 'New Money',
      badgeColor: '#d97706',
      isAvailable: true
    },
    {
      id: 'time_deposit',
      titleKey: 'tools.time_deposit_title',
      descKey: 'tools.time_deposit_desc',
      path: null,
      icon: 'trending_up',
      color: '#1d4ed8',
      bgColor: '#dbeafe',
      badge: null,
      isAvailable: false
    },
    {
      id: 'spending_split',
      titleKey: 'tools.spending_split_title',
      descKey: 'tools.spending_split_desc',
      path: null,
      icon: 'pie_chart',
      color: '#7e22ce',
      bgColor: '#f3e8ff',
      badge: null,
      isAvailable: false
    },
    {
      id: 'air_miles',
      titleKey: 'tools.air_miles_title',
      descKey: 'tools.air_miles_desc',
      path: null,
      icon: 'flight_takeoff',
      color: '#0f766e',
      bgColor: '#ccfbf1',
      badge: null,
      isAvailable: false
    }
  ];

  function openTool(tool) {
    if (tool.isAvailable && tool.path) {
      navigate(tool.path);
    } else {
      alertMessage = $t('tools.stay_tuned');
      showAlert = true;
      setTimeout(() => {
        showAlert = false;
      }, 2500);
    }
  }
</script>

<div class="tools-page">
  <div class="container">
    <!-- Header Banner -->
    <div class="banner">
      <div class="banner-badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
      </div>
      <div>
        <h1>{$t('tools.title')}</h1>
        <p>{$t('tools.subtitle')}</p>
      </div>
    </div>

    <!-- Alert toast -->
    {#if showAlert}
      <div class="toast-alert">
        <span>ℹ️</span>
        <span>{alertMessage}</span>
      </div>
    {/if}

    <!-- Tools Grid -->
    <div class="tools-grid">
      {#each tools as tool}
        <div class="tool-card {tool.isAvailable ? 'available' : 'coming-soon'}" on:click={() => openTool(tool)}>
          <div class="tool-top">
            <div class="tool-icon" style="background-color: {tool.bgColor}; color: {tool.color};">
              {#if tool.icon === 'receipt'}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z"></path><line x1="8" y1="6" x2="16" y2="6"></line><line x1="8" y1="10" x2="16" y2="10"></line><line x1="8" y1="14" x2="12" y2="14"></line></svg>
              {:else if tool.icon === 'account_balance'}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="21" x2="21" y2="21"></line><line x1="3" y1="10" x2="21" y2="10"></line><polygon points="12 2 2 7 22 7 12 2"></polygon><line x1="7" y1="10" x2="7" y2="21"></line><line x1="12" y1="10" x2="12" y2="21"></line><line x1="17" y1="10" x2="17" y2="21"></line></svg>
              {:else if tool.icon === 'trending_up'}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
              {:else if tool.icon === 'pie_chart'}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg>
              {:else}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path></svg>
              {/if}
            </div>
            {#if tool.isAvailable && tool.badge}
              <span class="badge" style="background-color: {tool.bgColor}; color: {tool.badgeColor};">
                {tool.badge}
              </span>
            {:else}
              <span class="badge coming-soon-badge">
                {$t('tools.coming_soon')}
              </span>
            {/if}
          </div>

          <div class="tool-content">
            <h2 class="tool-title">{$t(tool.titleKey)}</h2>
            <p class="tool-desc">{$t(tool.descKey)}</p>
          </div>

          <div class="tool-footer">
            {#if tool.isAvailable}
              <span class="action-link">{$t('tools.open_tool')} →</span>
            {:else}
              <span class="action-muted">{$t('tools.coming_soon')}</span>
            {/if}
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .tools-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem 1rem 3rem;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .container {
    width: 100%;
    margin: 0 auto;
  }

  .banner {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
    border-radius: 16px;
    padding: 24px;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 18px;
    margin-bottom: 24px;
    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.1);
  }

  .banner-badge {
    background: rgba(212, 175, 55, 0.2);
    color: #d4af37;
    padding: 14px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .banner h1 {
    font-size: 22px;
    font-weight: 800;
    margin: 0 0 6px 0;
  }

  .banner p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
  }

  .toast-alert {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #0f172a;
    color: #ffffff;
    padding: 12px 18px;
    border-radius: 10px;
    margin-bottom: 18px;
    font-size: 13px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .tools-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 18px;
  }

  .tool-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  }

  .tool-card.available:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
  }

  .tool-card.coming-soon {
    opacity: 0.85;
    background: #fafafa;
  }

  .tool-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
  }

  .tool-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .badge {
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 20px;
  }

  .coming-soon-badge {
    background: #f1f5f9;
    color: #64748b;
  }

  .tool-content {
    flex: 1;
  }

  .tool-title {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 6px 0;
  }

  .tool-desc {
    font-size: 13px;
    color: #64748b;
    line-height: 1.4;
    margin: 0 0 16px 0;
  }

  .tool-footer {
    border-top: 1px solid #f1f5f9;
    padding-top: 12px;
  }

  .action-link {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
  }

  .action-muted {
    font-size: 12px;
    color: #94a3b8;
  }

  @media (max-width: 640px) {
    .tools-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
